import { SonarText } from '@ui/text';
import React, { PropsWithChildren } from 'react';

export interface BulkEditModalSectionProps {
	title: string;
}

export const BulkEditModalSection: React.FC<PropsWithChildren<BulkEditModalSectionProps>> = ({
	children,
	title
}) =>
	<div className='bulk-edit-modal-section'>
		<SonarText weight='semibold'>{ title }</SonarText>
		{ children }
	</div>;
